<template>
	<div class="contact">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<p class="">说明：私信只有后台管理员可见，管理员会在收到私信的三个工作日内进行答复。<br/>
		所有发送和接收的私信均可在“消息-私信记录”页面进行查看和回复。</p>
		<span>标题</span> <span><el-input v-model='title' class="inputName"></el-input></span><br />
		<span class="cont">内容</span> <span>
			<!--<textarea name="" rows="20" cols="110" class="inputName area" :value="content"></textarea>-->
			 <el-input type="textarea" v-model="content" class="inputName area" rows="20" cols="110"></el-input>
		</span>
		<el-button type="primary" round class="commitFirst" @click="commit">发送</el-button>
		<div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				title:'',
				content:''
			}
		},
		methods:{
			commit(){
				var form = new FormData
				form.append('title',this.title)
				form.append('content',this.content)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/letter/add',
					data:form,
					withCredentials:true
				}).then(res =>{
                    this.$confirm(res.data.message, '提示', {
			          confirmButtonText: '确定',
			          showCancelButton:false,
			          type: 'info'
			        }).then(() => {
			          this.title = ''
					  this.content = ''
			        }).catch(() => {
			                  
			        });
					
				})
			}
		}
	}
</script>

<style scoped>
	.contact{
		font-size: 16px;
		padding: 15px 0 0 20px; margin-top: -286px;
	}
	.inputName{
		width: 420px;
		border-radius: 15px;
		padding: 20px;
		outline: none;
	}
	.area{
		width: 660px;
	}
	.cont{
		display: inline-block;
		vertical-align: top;
		
	}
	.commitFirst{
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 80px auto;
	}
	.big{
		font-size: 24px;
	}
	.mid{
		font-size: 20px;
		margin-top: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/views/sendLetter.vue